import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új partner',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-file-download"></i>',
                title: 'Export',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'exportRow'
            },
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        searchFields: [
            {
                name: "name",
                label: "Név",
                formType: "text",
                formSize: 3
            },
            {
                name: "fullName",
                label: "Teljes név",
                formType: "text",
                formSize: 3
            },
            {
                name: "companySiteId",
                label: "Telephely",
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getCompanySitesByCompanyId,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "name",
                label: "Név",
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 2,
                formVisible: true
            },
            {
                name: "fullName",
                label: "Teljes név",
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 4,
                formVisible: true
            },
            {
                name: "taxNumber",
                label: "Adószám",
                visibility: true,
                formType: "text",
                formSize: 2,
                formVisible: true
            },
            {
                name: "registrationNumber",
                label: "Cégjegyzékszám",
                visibility: false,
                formType: "text",
                formSize: 2,
                formVisible: true
            },
            {
                name: "companySiteId",
                label: "Telephely",
                visibility: false,
                formRequired: true,
                formType: "select",
                formSize: 2,
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getCompanySitesByCompanyId,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "baseAddressId",
                label: "baseAddressId",
                visibility: false,
                formType: 'number',
            },
            {
                name: "baseAddress",
                visibility: false,
                formVisible: false
            },
            {
                name: "address",
                visibility: false,
                formType: 'address',
                formVisible: true
            },
            {
                name: "createdBy",
                label: "createdBy",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "createdOn",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "deleted",
                label: "deleted",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
